export const calculateFee = (amount: number, fee: number) => {
  return Math.floor(amount * fee)
}
